import React from 'react'
import { Button, Carousel, Col, Row } from 'react-bootstrap'
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md'
import data from '../../data/carouselItemsDynamicKilt.json'

const StepSelector = (props) => {
   const { setCurrentStepIndex, currentStepIndex = 0 } = props
   const items = data.map(step => {
      return (
         <Carousel.Item key={step.name}>
            <Row>
               <Col className='text-center'>
                  <h5 className='text-secondary'>
                     {step.name}
                  </h5>
               </Col>
            </Row>
         </Carousel.Item>
      )
   })

   const handleActiveIndexChanged = (eventKey, event) => {
      setCurrentStepIndex(eventKey)
   }

   const nextIcon = (<Button size='sm' variant='dark'><MdNavigateNext /></Button>)
   const previousIcon = <Button size='sm' variant='dark' > <MdNavigateBefore /> </Button>

   return (
      <Carousel
         nextIcon={nextIcon}
         prevIcon={previousIcon}
         className='mt-4'
         wrap={false}
         activeIndex={currentStepIndex}
         variant="dark"
         fade={false}
         indicators={false}
         interval={null}
         onSelect={handleActiveIndexChanged}>
         {items}
      </Carousel>
   )
}
export default StepSelector